/* An overworld castle */
import kontra from 'kontra';

import { normalize, length } from '../utilities';
import { MAX_CASTLE_SPEED, CASTLE_DRAG } from '../constants';

import castleImage from '../../assets/castle.png';
import redFlag from '../../assets/redFlag.png';
import blueFlag from '../../assets/blueFlag.png';
import inhabitedTexture from '../../assets/inhabited.png';
import targetTexture from '../../assets/target.png';
import candidateTexture from '../../assets/candidate.png';

const { Sprite, SpriteSheet, imageAssets, emit, on } = kontra;

export default class Castle extends Sprite.class {
  constructor (properties) {
    const { name, ...otherProps } = properties;
    super(otherProps);

    this.name = name;

    this.width = 64;
    this.height = 64;
    this.image = imageAssets[castleImage];

    this.inhabited = false; // current location
    this.target = false; // reachable from here

    this.targetSheet = SpriteSheet({
      image: imageAssets[targetTexture],
      frameWidth: 72,
      frameHeight: 72,
      animations: {
        // create a named animation: walk
        ping: {
          frames: '0..2', // frames 0 through 9
          frameRate: 4
        }
      }
    });

    this.targetSprite = Sprite({
      x: this.x,
      y: this.y,
      anchor: { x: 0.5, y: 0.5 },
      animations: this.targetSheet.animations
    });

    this.candidateSheet = SpriteSheet({
      image: imageAssets[candidateTexture],
      frameWidth: 72,
      frameHeight: 72,
      animations: {
        // create a named animation: walk
        ping: {
          frames: '0..2', // frames 0 through 9
          frameRate: 4
        }
      }
    });

    this.candidateSprite = Sprite({
      x: this.x,
      y: this.y,
      anchor: { x: 0.5, y: 0.5 },
      animations: this.candidateSheet.animations
    });

    this.spriteSheet = SpriteSheet({
      image: imageAssets[inhabitedTexture],
      frameWidth: 72,
      frameHeight: 72,
      animations: {
        // create a named animation: walk
        ping: {
          frames: '0..2', // frames 0 through 9
          frameRate: 4
        }
      }
    });

    this.inhabitedSprite = Sprite({
      x: this.x,
      y: this.y,
      anchor: { x: 0.5, y: 0.5 },
      animations: this.spriteSheet.animations
    });

    on('unselect-all-castles', () => {
      this.target = false;
    });
  }

  update () {
    super.update();

    const speed = { x: this.dx, y: this.dy };

    const currentSpeed = length(speed);

    if (currentSpeed > MAX_CASTLE_SPEED) {
      const normalized = normalize(speed);

      this.dx = normalized.x * MAX_CASTLE_SPEED;
      this.dy = normalized.y * MAX_CASTLE_SPEED;
    }

    // Slow down castles
    this.dx *= 1 - CASTLE_DRAG;
    this.dy *= 1 - CASTLE_DRAG;

    [this.inhabitedSprite, this.candidateSprite, this.targetSprite].map(
      s => {
        s.update();
        s.x = this.x + 32;
        s.y = this.y + 54;
      });
  }

  onDown () {
    if (this.candidate && !this.inhabited) {
      emit('unselect-all-castles');
      this.target = true;
      emit('target-castle', this);
    }
  }

  render () {
    if (this.inhabited) {
      this.inhabitedSprite.render();
    } else if (this.target) {
      this.targetSprite.render();
    } else if (this.candidate) {
      this.candidateSprite.render();
    }

    this.context.drawImage(this.image, this.x, this.y);
  }
}
